/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Allow_All_TitleInputs */



/**
* | output |
* | --- |
* | "All tools are offered" |
*
* @param {Rights_Tools_Allow_All_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_allow_all_title = /** @type {((inputs?: Rights_Tools_Allow_All_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Allow_All_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Tools werden angeboten")
	return /** @type {LocalizedString} */ ("All tools are offered")
});